<template>
  <section class="container-term">
    <div v-html="term.content"/>
    <div class="version">Version : {{ term.version }} </div>
  </section>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      term: {
        content: '',
        version: '',
      },
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      if (this.$route.name) {
        const data = await this.$store.dispatch('getTermsCondsByType', this.$route.name.toLowerCase());
        this.term = data;
      }
    },
  }
};
</script>

<style scoped>
.container-term {
  margin: 20px;
}
.container-term h1,
.container-term h2 {
  color: #2c3e50;
}

.container-term li {
  margin-bottom: 8px;
}
.version {
  margin-top: 20px;
  margin-bottom: 20px;
  font-size: 0.8em;
  color: #888;
}
</style>
<style src="@/assets/styles/modals.css"></style>
